export default "__VITE_ASSET__DxFw27FK__"